// extracted by mini-css-extract-plugin
module.exports = {"style":"SolidButton_style__1eq9J","disabled":"SolidButton_disabled__24yso","titleStyle":"SolidButton_titleStyle__1oCjf"};